const GA_ID = process.env.GA_ID

function gtag() {
  window.dataLayer.push(arguments)
}

const google = ({ path }) => {
  gtag('config', GA_ID, {
    page_path: path,
  })
}

export default google



// WEBPACK FOOTER //
// ./src/router/google.js